import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const UpgradeAddonModalQrContainer = styled.div<React.CSSProperties>`
  margin-bottom: ${Screen.widthRatio * 30}px;
  margin-top: ${Screen.widthRatio * 30}px;
`;

export default UpgradeAddonModalQrContainer;
